import { PalmaresBlockProps } from "@components/PageComponents/LeClub/Palmares/PalmaresBlock";

const palmares: PalmaresBlockProps[] = [
  {
    titre: "EU Challenger League '21",
    imageCompetition: "/logoPalmares/EUCL.png",
    placement: "Top 3",
  },
  {
    titre: "6 French League '21",
    placement: "TOP 3",
    imageCompetition: "/logoPalmares/6FL.png",
  },
  {
    titre: "6 Open Cup '21",
    placement: "TOP 3",
    imageCompetition: "/logoPalmares/6OC.png",
  },
  {
    titre: "SI: Open Qualifier",
    placement: "TOP 1",
    imageCompetition: "/logoPalmares/SI.png",
  },
  {
    titre: "6 French Challengers '20",
    placement: "TOP 1",
    imageCompetition: "/logoPalmares/6FC.png",
  },
  {
    titre: "Gamers Assembly '19",
    // placement: "Participation",
    imageCompetition: "/logoPalmares/GA.png",
  },
  {
    titre: "Coupe de France '18",
    placement: "Top 3",
    imageCompetition: "/logoPalmares/CDF2018.webp",
  },
  {
    titre: "DreamHack Tours '16",
    // placement: "Participation",
    imageCompetition: "/logoPalmares/DreamHack.png",
  },
];

export default palmares;
